var notifications = (function($) {

	var _init = function() {
		var $notifications = $( '.account-notification' );

		$notifications.find( 'a.dismiss' ).on( 'click', _dismiss_click_handler );
	};

	var _dismiss_click_handler = function( e ) {
		e.preventDefault();
		e.stopImmediatePropagation();

		_dismiss( $( this ).closest( '.account-notification' ) );
	};

	var _dismiss = function( $notification ) {
		$notification.loading();

		var data = {
			action: 'crate_dismiss_notification',
			notification: $notification.data( 'notification-id' ),
			nonce: ScriptData.crate_dismiss_notification_nonce
		};

		$.post( ScriptData.ajaxurl, data, function( response ) {
			if ( response.success ) {
				$notification.remove();
			} else {
				$notification.loaded();
			}
		} );
	};

	$( document ).on( 'ready', _init );

})(jQuery);

module.exports = notifications;